import React from 'react';

const Encabezado = (props) => {

    let encabezado = undefined;
    let claseEncabezado = undefined;

    //Empresa Aceptada por Administradora, se visualiza la misma
    if (props.data.empresaSolicitud) {
        claseEncabezado = "row marked top-separator-xs";
        encabezado = <div className="col-md-12">
            <div className="row top-separator-xxs">
                <div className="col-md-12">
                    <label className="label-primary">Empresa:</label>
                </div>
            </div>
            <div className="row">
                <div className="col-md-12"><p>{props.data.empresa.Descripcion}</p></div>
            </div>
        </div>
    }

    //Empresa y Cuenta Aceptada por Administradora, se visualizan ambas
    if (props.data.cuentaSolicitud) {
        claseEncabezado = "row marked top-separator-xs";
        encabezado = <div className="col-md-12">
            <div className="row top-separator-xxs">
                <div className="col-md-12">
                    <label className="label-primary">Empresa:</label>
                </div>       
                <div className="col-md-12"><p>{props.data.empresa.Descripcion}</p></div>
                <div className="col-md-12">
                    <label className="label-primary">Cuenta:</label>
                </div>
                    <div className="col-md-12"><p>{props.data.cuentas[0].Descripcion}</p></div>
            </div>
        </div>
    }

    return (
        <div className={claseEncabezado}>
            {encabezado}
        </div>
    );
}

export default Encabezado;